var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgetHtml)?_c('div',[_c('div',{ref:"banner",staticClass:"sidebar-banner-content pa-2 mx-5 my-3",domProps:{"innerHTML":_vm._s(_vm.widgetHtml)}}),_c('divider')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }